var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3155 29.1307C20.0398 28.8267 21.6874 28.186 23.1642 27.2452C24.6409 26.3044 25.9179 25.0819 26.9222 23.6476C27.9265 22.2133 28.6385 20.5953 29.0174 18.8858C29.3964 17.1764 29.435 15.409 29.1309 13.6847C28.8269 11.9603 28.1862 10.3127 27.2454 8.83596C26.3046 7.35922 25.0821 6.08224 23.6478 5.07793C22.2135 4.07362 20.5955 3.36166 18.886 2.98268C17.1766 2.6037 15.4092 2.56514 13.6849 2.86919C11.9605 3.17324 10.3129 3.81395 8.83617 4.75474C7.35942 5.69553 6.08244 6.91797 5.07813 8.35228C4.07382 9.78658 3.36186 11.4046 2.98288 13.1141C2.6039 14.8236 2.56534 16.5909 2.86939 18.3153C3.17344 20.0396 3.81415 21.6872 4.75494 23.164C5.69573 24.6407 6.91818 25.9177 8.35248 26.922C9.78678 27.9263 11.4049 28.6383 13.1143 29.0172C14.8238 29.3962 16.5911 29.4348 18.3155 29.1307L18.3155 29.1307Z",
    stroke: "#2042B8",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16L16 24",
    stroke: "#2042B8",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.33337L16 8.00004",
    stroke: "#2042B8",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.b394f04881bca9a312d64d3fe1224d20.svg";
export { ForwardRef as ReactComponent };